// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App.vue'
import ElementUI, { Message }  from 'element-ui'
import "../element-variables.scss"
import store from './store/index.js'
import animated from 'animate.css'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
import visually from '@/directives/visually'
import logoLoading from '@/directives/logoLoading.js'

import "@/assets/css/defined.less"

// 页面引导
import "driver.js/dist/driver.min.css";
import "../src/assets/css/guide.css"

import "./filters/filters"

import {getIsOpen} from "../common/requestBaseData";


// //  Message
// import { Message } from "element-ui"

// 鼠标右键模拟组件
import VueContextMenu from 'vue-contextmenu'
Vue.use(VueContextMenu)
import Utils from "../common/util.js";
Vue.use(VueViewer);
Vue.use(animated);
Vue.use(ElementUI);
import Setnum from '../common/setNumber.js';
import * as filters from './filters'
import * as echarts from 'echarts';
import { loginOut } from "@/assets/js/utils.login";
import { isObject } from "@/assets/js/utils";
Vue.prototype.ossPath = 'https://huodaipin-test.oss-cn-hongkong.aliyuncs.com/web/v1.0.0'
Vue.prototype.$echarts = echarts;
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
});
Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.directive('visually', visually)
Vue.directive('logoLoading', logoLoading)

import devParams from '../devParams'
if (process.env.NODE_ENV === 'development') {
  if (!devParams.openProxy) axios.defaults.baseURL = devParams.proxyTarget
}

console.log("axios.defaults.baseURL = ", axios.defaults.baseURL);

axios.interceptors.request.use(config => {
  if (config.url) {
    let hasUrlApi = /^\/(api|cms|ies)/.test(config.url); //是否包含api
    let myRegExp = new RegExp("^[a-zA-Z]");
    if (!hasUrlApi) {
      config.url = `/api${config.url}`; //非开发环境
      // config.url = 'http://8.134.131.100:8080/api' + config.url;//开发环境
    }
  }
  let user = store.state.Authorization;
  if (isObject(user) && user.token) config.headers.token = user.token;
  if (!config.headers.source) config.headers.source = 'WEB';
  return config
});

Vue.prototype.$Setnum = Setnum
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      // if (error.response.status == '504') {
      if (error.response.status == '401') {
        // confirm('登录已过期,请重新登录---');
        Message({
          showClose: true,
          type: "error",
          message: "登录已过期,请重新登录"
        })
        // localStorage.clear();
        setTimeout(() => {
          loginOut();
          store.commit("changeloginShow", true);
          console.log(router.app.$route.path)
          if (
            router.app.$route.path != "/" &&
            router.app.$route.path != "/placeOrder/introduce" &&
            router.app.$route.path != "/404" &&
            router.app.$route.path != "/placeOrder/Trajectory" &&
            router.app.$route.path != "/placeOrder/placeindexInfo/queryPrice" &&
            router.app.$route.path != "/placeOrder/placeindexInfo/Smallbag" &&
            router.app.$route.path != "/placeOrder/Guide" &&
            router.app.$route.path != "/news" &&
            router.app.$route.path != "/newsDetails" &&
            router.app.$route.path != "/NewOrder/newBillCargo" &&
            router.app.$route.path != "/placeOrder/platformSharedWarehouse" &&
            router.app.$route.path != "/placeOrder/saas" &&
            router.app.$route.path != "/placeOrder/supplyChainFinanceApply" &&
            router.app.$route.path != "/placeOrder/supplierJoin" &&
            router.app.$route.path != "/placeOrder/placeindexInfo/inquiryHall" &&
            router.app.$route.path != "/placeOrder/inquiryTakeOrder" &&
            router.app.$route.path != "/placeOrder/publishedInquiry" &&
            router.app.$route.path != "/takeOrder" &&
            router.app.$route.path != "/placeOrder/MemberZone" &&
            router.app.$route.path != "/placeOrder/MemberZoneDetail"
          ) {
            router.replace("/index")
          } else {
            const unLoginPages = ['/placeOrder/inquiryTakeOrder', '/placeOrder/publishedInquiry', '/takeOrder']
            if (unLoginPages.includes(router.app.$route.path)) {
              router.replace({
                path: '/'
              })
              store.commit("changeactive", 1)
              store.commit("changeSetType", false);
              store.commit("changeLogoshow", true); //打开logo
              Utils.$emit("changeNav", 1);
            }
          }
        }, 1000)
        // window.location.reload()
      }
    }
    return Promise.reject(error.response.data)
  })


// router.beforeEach((to,from,next)=>{
//   console.log(to)
//   if(to.path!=='/'){

//   }

//   next()
// })

 // filters.js
Vue.filter('formatDate', function (date, formatString) {
  formatString = formatString || 'YYYY-MM-DD';
  if (typeof date === 'undefined' || !date) return date;
  date = new Date(date)
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return formatString
    .replace('yyyy', year)
    .replace('MM', month)
    .replace('dd', day)
    .replace('HH', hours)
    .replace('mm', minutes)
    .replace('ss', seconds);
});

// import moment from 'moment/moment'
// Vue.prototype.$moment = moment
// Vue.filter('moment', function (value, formatString) {
//   formatString = formatString || 'YYYY-MM-DD';
//   return moment(value).format(formatString); // value可以是普通日期 20170723
//   // return moment.unix(value).format(formatString); // 这是时间戳转时间
// });

import { sessionGetUserInfo } from "@/assets/js/utils.session";
Vue.mixin({
  created() { this.sessionGetUserInfo = sessionGetUserInfo; },
});
/* eslint-disable no-new */


const Bus = new Vue();  // 添加总线
new Vue({
  el: '#app',
  data: { Bus },
  store,
  router,
  components: { App },
  template: '<App/>',
  mounted() {
    // setTimeout(() => {
    //   document.dispatchEvent(new Event('render-event'));
    // }, 1000)
    getIsOpen()
  }
})



// WEBPACK FOOTER //
// ./src/main.js